import { DeleteOutlined } from '@ant-design/icons';
import { Button, InputNumber, Space, Table, TableProps, Tag } from 'antd';
import React, { useContext, useEffect, useState } from 'react'
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import { CartUnit } from '../../Models/CartUnit';
import { Product } from '../../Models/Product';
import { useNavigate } from 'react-router-dom';
import { CartUnitCards } from '../../Models/CartUnitCards';
import { Inventary } from '../../Models/Inventary';

interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
    tags: string[];
  }
interface Props{
  closeModal?:() => void
  metodPayment:string
}

const sharedProps = {
  mode: 'spinner' as const,
};

const DetailCartTable = ({closeModal, metodPayment}:Props) => {
  const {cart, sendCart} = useContext(PromiseSesionContext);
  const {cartCard, sendCartCard} = useContext(PromiseSesionContext);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);   
  
  }, []);
  const scrollProps = isMobile ? { x: 1000, y:200} : { x: 100, y: 300 };
  const supCart = (inventary:Product)=>{

    sendCart({type: "DISC", data:{producto:inventary}})

  }

  const supCartCard = (inventary:Inventary)=>{

    sendCartCard({type: "DISC", data:{producto:inventary}})

  }

  const editCart = (inventary:Product, quantity:number)=>{

    sendCart({type: "EDIT", data:{producto:inventary, quantity:quantity}})

  }

    const editCartCard = (inventary:Inventary, quantity:number)=>{
  
      sendCartCard({type: "EDIT", data:{producto:inventary, quantity:quantity}})
  
    }

    const columns: TableProps<any>['columns'] = [
        {
          title: 'Imagen',
          key: 'imagen',
          align:"center",
          render: (_, record) => <div><img style={{objectFit:"contain", width:"60px"}} src={record.producto.image || record.producto.product.image_url} alt='Logo'></img> </div>,
        },
        {
            title: 'Detalle',
            key: 'precio',
            align:"center",
            render: (_, record) => <span>{record.producto.name || (record.producto.product.pokemonCard[0].name +" - "+record.producto.product.pokemonCard[0].sets.name + (`${record.producto.product.card_type!=="rare"? ` - (${record.producto.product.card_type})` : ""}`))}</span>,
  
        },
 
        {
            title: 'Precio',
            key: 'precio',
            align:"center",
            render: (_, record) =>{ 
              console.log("record ", record)
              if(record.type=="card"){
                return <span>${metodPayment=="pago movil" ? (record.producto.product.price.toFixed(1)) : record.producto.product.cash_price.toFixed(1)}</span>
                // return <span>{(record.producto.discount_price ? record.producto.discount_price :record.producto.price) || record.producto.product.price}</span>

              }
              else{
                return <span>${metodPayment=="pago movil" ?(record.producto.price.toFixed(1)) : (record.producto.cash_price.toFixed(1))}</span>

              }
          },
  
          },
        {
          title: 'Cantidad',
          dataIndex: 'cantidad',
          align:"center",
          render: (_, record) => {
            console.log("record ",record)
            if(record.type==="product"){
                return <InputNumber {...sharedProps} value={record.cantidad} onChange={(value)=>{editCart(record.producto, value|| 1)}}  min={0} max={record.producto.quantity} />
            }
            else{
              return <InputNumber {...sharedProps} value={record.cantidad} onChange={(value)=>{editCartCard(record.producto, value|| 1)}}  min={0} max={record.producto.quantity} />
            }
        },
        },
        {
          title: 'SubTotal',
          key: 'subTotal',
          align:"center",
          render: (_, record) => (<span>${metodPayment==="pago movil" ? `${(record.subTotal).toFixed(1)}` : `${(record.subTotalCash).toFixed(1)}`} </span>),
        },
        {
          title: 'Eliminar',
          key: 'eliminar',
          align:"center",
          render: (_, record) => {
            if(record.type==="product"){
              return <Button onClick={()=>{supCart(record.producto)}} danger type="text"><DeleteOutlined /></Button>
            }
              return <Button onClick={()=>{supCartCard(record.producto)}}  danger type="text"><DeleteOutlined /></Button>
            },
        },
      ];

    
  return (
    <Table<any> bordered={true} scroll={scrollProps} columns={columns} dataSource={[...cart.context.cart.productos, ...cartCard.context.cart.productos]} pagination={false}         locale={{
          emptyText: (
            <span>
              <p style={{ margin: 0 }}>Tu aventura comienza con un carrito vacío. 🗺️ Es la señal para explorar nuestro vasto multiverso de cartas TCG.</p>
              <p style={{ margin: 0, fontSize: '0.9em', color: '#888' }}>
                ¡Encuentra esos singles legendarios, sobres para abrir o colecciones completas que te esperan!
              </p>

              <div>
                <Button type="link" onClick={() =>{navigate("/productos"); if(closeModal)closeModal()}}>Productos</Button>
                <Button type="link" onClick={() =>{navigate("/cartas");if(closeModal)closeModal()}}>Cartas sueltas</Button>
              </div>
            </span>
          ),
        }} />
  )
}

export default DetailCartTable